import { Ionicons } from "@expo/vector-icons";
import { DrawerContentScrollView } from "@react-navigation/drawer";
import { Box, Divider, HStack, Icon, Text, VStack } from "native-base";
import React from "react";
import { Image, Pressable, View } from "react-native";
import { useSelector } from "react-redux";

import AppConstants from "../../utils/Constants";
import {
	getBrandLeftMenuBackgroundColor,
	getBrandLeftMenuTextColor,
	getMenuImg,
	isWeb,
} from "../../utils/utils";

const BRAND_URL = isWeb()
	? AppConstants.WindowHostname
	: AppConstants.CIP_BRAND;

const LoggedInDrawer = (props) => {
	const isXiaomi = BRAND_URL === AppConstants.XiaomiURL;
	const Auth = useSelector((state) => state.Login.Auth);

	return (
		<DrawerContentScrollView
			{...props}
			safeArea
			style={{
				padding: 10,
				flex: 1,
				backgroundColor: getBrandLeftMenuBackgroundColor(),
			}}
		>
			<VStack space="7" my="2" mx="1">
				<Box px="4" alignItems="center">
					<View
						style={{
							backgroundColor: "#d5d5d5",
							padding: 20,
							borderRadius: 80,
						}}
					>
						<Icon as={Ionicons} name="person-outline" size="xl" />
					</View>
					<Text fontWeight="900" color={getBrandLeftMenuTextColor()}>
						{`${
							Auth.profile.data.filter(
								(profile) => profile.type_name === "first_name"
							)[0]?.data_text
						} ${
							Auth.profile.data.filter(
								(profile) => profile.type_name === "second_name"
							)[0]?.data_text
						}`}
					</Text>
					<Text
						fontSize="14"
						mt="1"
						color={getBrandLeftMenuTextColor()}
						fontWeight="500"
					>
						{Auth.profile.role}
					</Text>
				</Box>
				<Divider />
				<VStack divider={<Divider />} space="4">
					<VStack space="3">
						{props.state.routeNames.map((name, index) => {
							if (name === "Profile" || name === "Dispute Claim") {
								return;
							}
							return (
								<Pressable
									px="5"
									py="3"
									rounded="md"
									bg={
										index === props.state.index ? "primary.600" : "transparent"
									}
									onPress={(event) => {
										props.navigation.navigate(name);
									}}
								>
									<HStack
										space="5"
										alignItems="center"
										padding={2}
										borderRadius={5}
										bg={
											index === props.state.index
												? "primary.100"
												: "transparent"
										}
									>
										<Icon
											color={
												index === props.state.index
													? "primary.500"
													: getBrandLeftMenuTextColor()
											}
											size="5"
											as={
												<Image
													resizeMode="contain"
													source={{
														uri: isWeb()
															? getMenuImg(name)
															: Image.resolveAssetSource(getMenuImg(name)).uri,
													}}
													style={{
														width: 20,
														height: 20,
														resizeMode: "contain",
													}}
												/>
											}
										/>

										<Text
											fontWeight="600"
											fontSize={14}
											color={
												index === props.state.index
													? "primary.500"
													: getBrandLeftMenuTextColor()
											}
										>
											{name}
										</Text>
									</HStack>
								</Pressable>
							);
						})}
					</VStack>
				</VStack>
			</VStack>
		</DrawerContentScrollView>
	);
};

export default LoggedInDrawer;
